import { TicketType } from "app/components/ReplyComment/redux/types";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import React, { FC } from "react";

interface TicketMentionItemProps {
  ticket: TicketType;
  onSelect: (ticket: TicketType) => void;
}

const iconBoxStyle = {
  width: 20,
  minWidth: 20,
  maxWidth: 20,
  height: 20,
  minHeight: 20,
  maxHeight: 20,
};

const TicketMentionItem: FC<TicketMentionItemProps> = ({
  ticket,
  onSelect,
}) => {
  return (
    <div
      className="flex items-center gap-2.5 px-4 py-2.5 h-[44px] outline-none cursor-pointer hover:bg-gray-100 transition-colors"
      onClick={() => onSelect(ticket)}
      onMouseDown={(e) => e.preventDefault()}
    >
      <div className="w-full flex flex-1 gap-2 items-center truncate">
        <div className="flex gap-1 truncate">
          <div
            className="flex items-center justify-center"
            style={iconBoxStyle}
          >
            <TicketTypeIcon iconName={ticket.type.icon} size={16} />
          </div>
          <span className="text-sm font-normal text-black truncate">
            {ticket.ticketID} {ticket.ticketName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TicketMentionItem;
